import { Controller, FormContext, useForm } from "react-hook-form";
import FormTitle from "../../FormElements/FormTitle";
import { stepPosition } from "../../../Store/simulate/actions";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Title from "../../FormElements/Title";
import ErrorCustom from "../../errorCustom";
import {
  validateEmail,
  validatePhoneVoid,
  validateTextOnlyAlphanumeric,
  validatorField,
} from "../../../Utils/validators";
import NumberFormat from "react-number-format";
import { Address } from "../../../Pages/wizard/Address";
import Button from "../../FormElements/Button";

interface Props {
  setFormInsuredValid: any;
  onSubmit: any;
  loading: any;
}

interface Object {
  companyName: any;
  companyGyre: any;
  position: any;
  yearsOfService: any;
  salary: any;
  phone: any;
  email: any;
  currency: any;
  chargeClient: any;
  address: any;
}

const myObject: Object = {
  companyName: "",
  companyGyre: "",
  position: "",
  yearsOfService: "",
  salary: "",
  phone: "",
  email: "",
  currency: "",
  chargeClient: "",
  address: "",
};

const InsuredForm = ({ onSubmit, setFormInsuredValid, loading }: Props) => {
  const methods = useForm({ mode: "onChange" });

  const {
    register,
    control,
    errors,
    handleSubmit,
    formState: { isValid },
  } = methods;
  const dataStoreClient = useSelector((state: any) => state.simulate.policy.client);
  const dispatch = useDispatch();

  let dataRedux;
  if (Object.entries(dataStoreClient).length !== 0) {
    const datosAsegurado = dataStoreClient.datosAsegurado;
    if (datosAsegurado && datosAsegurado.informacionLaboral) {
      dataRedux = datosAsegurado.informacionLaboral;
      dispatch(stepPosition(2));
      
      window.digitalData.push({
        virtual: {
          name: "aiv:inversion-global:cotizar:datos-laborales",
        },
        event: "trackVirtual",
      });
    }
  }

  const [isRetired, setIsRetired] = useState<any>(false);
  const [situacion, setSituacion] = useState<any>("Dependiente");

  const [nameUbigeo, setNameUbigeo] = useState<any>({
    province: "",
    department: "",
    district: "",
  });
  const [nameVia, setNameVia] = useState<any>({
    via: "",
  });

  const [otherCharge, setOtherCharge] = useState(false);

  const handleSituation = (e: any) => {
    const { value } = e.target;
    const validationCheck = value === "Jubilado";
    setIsRetired(validationCheck);
    setOtherCharge(value === "Otros");
    setSituacion(value);
  };

  const handleSubmitForm = (data: any) => {
    onSubmit({ ...data, isRetired, otherCharge });
  };

  useEffect(() => {
    window.digitalData.push({
      metadata: {
        key: "Situación Laboral – Inversión Global",
        value: situacion,
      },
      event: "trackMetadata",
    });
  }, [situacion]);

  useEffect(() => {
    setFormInsuredValid(isValid);
  }, [isValid]);

  const {
    companyName,
    companyGyre,
    position,
    yearsOfService,
    salary,
    phone,
    email,
    currency,
    chargeClient,
    address,
  } = dataRedux || myObject;

  return (
    <>
      <FormTitle
        title="Ingresa los datos laborales del asegurado"
        parrafo="El contratante es la persona que es titular de la póliza y asegurado a la vez."
      />
      <FormContext {...methods}>
        <form onSubmit={handleSubmit(handleSubmitForm)}>
          <Title title="Situación laboral" />
          <div className="clientForm__form__block">
            <p>
              <label>
                <input
                  className="with-gap"
                  name="situation"
                  id="dependent"
                  type="radio"
                  value="Dependiente"
                  ref={register()}
                  onChange={(e) => handleSituation(e)}
                  defaultChecked={true}
                />
                <span>Dependiente</span>
              </label>
            </p>
            <p>
              <label>
                <input
                  className="with-gap"
                  name="situation"
                  id="independent"
                  value="Independiente"
                  ref={register()}
                  onChange={(e) => handleSituation(e)}
                  type="radio"
                />
                <span>Independiente</span>
              </label>
            </p>
            <p>
              <label>
                <input
                  className="with-gap"
                  name="situation"
                  id="retired"
                  value="Jubilado"
                  ref={register()}
                  onChange={(e) => handleSituation(e)}
                  type="radio"
                />
                <span>Jubilado</span>
              </label>
            </p>
            <p>
              <label>
                <input
                  className="with-gap"
                  name="situation"
                  id="other"
                  value="Otros"
                  ref={register()}
                  onChange={(e) => handleSituation(e)}
                  type="radio"
                />
                <span>Otros</span>
              </label>
            </p>
          </div>

          {!isRetired && !otherCharge && (
            <>
              <Title title="Empresa" />
              <div className="clientForm__control input-field">
                <input
                  name="companyName"
                  id="companyName"
                  className={errors["companyName"] ? "is-error" : ""}
                  autoComplete="off"
                  maxLength={50}
                  ref={register({
                    validate: validatorField,
                  })}
                  defaultValue={companyName}
                  type="text"
                />
                <label
                  className={companyName ? "active" : ""}
                  htmlFor="companyName"
                >
                  Razón social
                </label>
                <ErrorCustom errors={errors} name="companyName" />
                <div className="errorCustom">
                  {errors["profession"] &&
                    "*Nombre de la razón social incorrecto."}
                </div>
              </div>
              <div className="clientForm__control input-field">
                <input
                  id="companyGyre"
                  name="companyGyre"
                  className={errors["companyGyre"] ? "is-error" : ""}
                  autoComplete="off"
                  maxLength={100}
                  ref={register({
                    validate: validateTextOnlyAlphanumeric,
                  })}
                  defaultValue={companyGyre}
                  type="text"
                />
                <label
                  className={companyGyre ? "active" : ""}
                  htmlFor="companyGyre"
                >
                  Giro de la empresa
                </label>
                <ErrorCustom errors={errors} name="companyGyre" />
              </div>

              <Title title="Datos del rol actual" />
              <div className="group-form">
                <div className="clientForm__control input-field">
                  <input
                    type="text"
                    className={errors["position"] ? "is-error" : ""}
                    id="position"
                    name="position"
                    autoComplete="off"
                    maxLength={50}
                    ref={register({
                      validate: validateTextOnlyAlphanumeric,
                    })}
                    defaultValue={position}
                  />
                  <label
                    className={position ? "active" : ""}
                    htmlFor="position"
                  >
                    Cargo
                  </label>
                  <ErrorCustom errors={errors} name="position" />
                </div>

                <div className="clientForm__control input-field">
                  <Controller
                    as={NumberFormat}
                    name="yearsOfService"
                    className={`input ${
                      errors["yearsOfService"] ? "is-error" : ""
                    }`}
                    control={control}
                    maxLength={2}
                    rules={{ required: true, minLength: 1 }}
                    defaultValue={yearsOfService}
                  />
                  <label
                    className={yearsOfService ? "active" : ""}
                    htmlFor="yearsOfService"
                  >
                    Años de servicio
                  </label>
                  <ErrorCustom errors={errors} name="yearsOfService" />
                </div>
              </div>

              <div className="clientForm__control__inputSelect woker">
                <select
                  className={`browser-default ${
                    errors.currency ? "is-error" : ""
                  }`}
                  name="currency"
                  ref={methods.register({ validate: validatorField })}
                  defaultValue={currency}
                >
                  <option value="" disabled selected>
                    Moneda
                  </option>
                  <option value="PEN">Soles</option>
                  <option value="USD">Dólares</option>
                </select>
                <div className="input-field">
                  <Controller
                    as={NumberFormat}
                    className={`input ${errors["salary"] ? "is-error" : ""}`}
                    thousandSeparator
                    decimalScale={2}
                    decimalSeparator="."
                    name="salary"
                    control={control}
                    defaultValue={salary}
                    maxLength={10}
                    rules={{ required: true, maxLength: 10 }}
                  />
                  <label className={salary ? "active" : ""} htmlFor="salary">
                    Ingresos totales al mes
                  </label>
                  <ErrorCustom errors={errors} name="salary" />
                </div>
              </div>

              <Title title="Datos de contacto" />

              <div className="clientForm__control input-field is-optional">
                <input
                  type="text"
                  className={phone ? "is-error" : ""}
                  autoComplete="off"
                  id="phone"
                  name="phone"
                  maxLength={9}
                  ref={register({ validate: validatePhoneVoid })}
                  defaultValue={phone}
                />
                <label className={phone ? "active" : ""} htmlFor="phone">
                  Teléfono laboral
                </label>
                <div>(opcional)</div>
              </div>
              <ErrorCustom errors={errors} name="phone" />

              <div className="clientForm__control input-field">
                <input
                  type="text"
                  className={errors["email"] ? "is-error" : ""}
                  autoComplete="off"
                  id="email"
                  name="email"
                  ref={register({ validate: validateEmail })}
                  defaultValue={email}
                  maxLength={38}
                />
                <label className={email ? "active" : ""} htmlFor="email">
                  Correo electrónico laboral
                </label>
                <ErrorCustom errors={errors} name="email" />
              </div>

              <Title title="Dirección laboral" />
              <Address
                nameUbigeo={nameUbigeo}
                setNameUbigeo={setNameUbigeo}
                nameVia={nameVia}
                setNameVia={setNameVia}
                dataRedux={address}
              />
            </>
          )}
          {otherCharge && (
            <>
              <Title title="Cargo" />
              <div className="clientForm__control input-field">
                <input
                  name="chargeClient"
                  id="chargeClient"
                  className={errors["chargeClient"] ? "is-error" : ""}
                  autoComplete="off"
                  maxLength={50}
                  ref={register({
                    validate: validatorField,
                  })}
                  defaultValue={chargeClient}
                  type="text"
                />
                <label
                  className={chargeClient ? "active" : ""}
                  htmlFor="chargeClient"
                >
                  Indique a que se dedica
                </label>
              </div>
            </>
          )}
          <div className="form-register__border"></div>
          <div className="form-register__buttom form-step">
            <Button
              type="submit"
              className={loading ? "is-loading" : ""}
              disabled={!isValid ? true : false}
            >
              Continuar
            </Button>
          </div>
        </form>
      </FormContext>
    </>
  );
};

export default InsuredForm;
